import { SYSAction, SYSConfig } from "../../../../_ovlclient/src"
import {
  DialogClose,
  DialogOkCancel,
  DialogSetLock,
} from "../../../../_ovlclient/src/library/dialog/dialogapi"
import type { SYSFormState } from "../../../../_ovlclient/src/library/forms/fieldapi"
import {
  FieldReset,
  FieldSetVal,
  FieldVal,
} from "../../../../_ovlclient/src/library/forms/fieldapi"

import { Data } from "../../../../_ovlclient/src/dataapi"

import {
  ProcessEnd,
  ProcessStart,
} from "../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { SnackAdd } from "../../../../_ovlclient/src/library/snackapi"
import { T } from "../../../../_ovlclient/src/textapi"
import { InitStateFromLogin } from "./helpers"
import { ValidationsAdd } from "../../../src/library/forms/validatorsapi"
import { isFirefox, isIOS } from "../../../src/global/globals"
import { FormReset } from "../../../src/library/forms/formapi"
import { ValidationsRemove } from "../../../src/library/forms/validators"

const Login: SYSAction<{
  formState?: SYSFormState
}> = async (value, { global }) => {
  let user
  let pw
  let formState: SYSFormState
  let userField
  let pwField
  ProcessStart("SYSLoginLogin", {
    lock: { dialog: "SYSLogin", formState },
  })
  try {
    let formState = value.formState

    let res

    userField = formState.fields["user"]
    pwField = formState.fields["pw"]

    // if (isIOS() || isFirefox()) {
    //   debugger
    //   // somehow on ios we don't get the password field value when automatically inserted
    //   // this is a workaround to force the autofilled password value into the field state
    //   let pwElement = <HTMLInputElement>document.getElementById(pwField.id)
    //   if (pwElement.value && !pwField.convertedValue) {
    //     await FieldSetVal(pwField, pwElement.value, {
    //       ignoreCustomValidation: true,
    //       ignoreValueChanged: true,
    //     })
    //   }
    //   let userElement = <HTMLInputElement>document.getElementById(userField.id)
    //   if (userElement.value && !userField.convertedValue) {
    //     await FieldSetVal(userField, userElement.value, {
    //       ignoreCustomValidation: true,
    //       ignoreValueChanged: true,
    //     })
    //   }
    // }

    user = FieldVal(userField)
    pw = FieldVal(pwField)
    let state = global.getState()
    try {
      res = await Data("users/authenticate", {
        user,
        password: pw,
        language: state.ovl.session.Language,
        clientId: state.ovl.app.clientId,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
    } catch (err) {
      if (err.type) {
        if (err.type === "InvalidCredentials") {
          ValidationsAdd(
            [pwField, userField],
            "SYSLoginValidationInvalidPassword",
            "Validate",
            {
              setFocus: true,
              validation: {
                summaryDisplayType: "Always",
              },
            }
          )
        }
      }
      return
    }
    if (res.TOTPCanceled) {
      return
    }
    await InitStateFromLogin(res)
    // important! close dialog after initstate because it's awaited in the bootstrap init process
    await DialogClose("SYSLogin")
    FormReset(formState)
  } finally {
    ProcessEnd("SYSLoginLogin")
  }
}

const ForgotPw: SYSAction<SYSFormState> = async (value, { global }) => {
  if (
    (await DialogOkCancel(T("SYSLoginForgotPasswordConfirm"), {
      defaultButton: 2,
    })) === 1
  ) {
    DialogSetLock("SYSLogin", true)
    try {
      let res
      let user = FieldVal(value.fields["user"])
      let state = global.getState()
      res = await Data("users/requestresetpw", {
        user,
        langCode: state.ovl.session.Language,
        url: location.href,
      })
      SnackAdd(T("SYSLoginForgotPasswordMsg"), "Information", 20000)
    } finally {
      DialogSetLock("SYSLogin", false)
    }
  }
}

export let actions = { Login, ForgotPw }
